import { useState } from "react";
import styles from "./UnitScholarAndPeers.module.scss";
import { Tab, Tabs } from "@mui/material";
import UnitScholarList from "./UnitScholarList";
import UnitPublicationList from "./UnitPublicationList";
import UnitAwardList from "./UnitAwardList";
import UnitCollaboratorList from "./UnitCollaboratorList";
import { useDispatch } from "react-redux";
import { setCurrentTab, setSelectedKeywords } from "Redux/Slices/Concept";

const UnitScholarAndPeers = ({ summary }) => {
  const dispatch = useDispatch();
  const [tab, setTab] = useState(0);
  const tabs = [
    {
      label: "Scholars",
      key: "scholars",
      children: <UnitScholarList />,
      visibile: summary.has_faculties,
    },
    {
      label: "Notable Scholarly Works",
      key: "publications",
      children: <UnitPublicationList />,
      visibile: summary.has_publications,
    },
    {
      label: "Notable Federal Grants",
      key: "grants",
      children: <UnitAwardList />,
      visibile: summary.has_grants,
    },
    {
      label: "Collaborators",
      key: "collaborators",
      children: <UnitCollaboratorList />,
      visibile: summary.has_collaborators,
    },
  ].filter((tab) => tab.visibile);

  const handleChange = (event, newValue) => {
    setTab(newValue);
    dispatch(setCurrentTab(tabs[newValue].key));
  };

  return tabs.length === 0 ? null : (
    <div className={styles["unit-scholar-and-peers"]}>
      <Tabs
        className={styles["tabs"]}
        value={tab}
        onChange={handleChange}
        variant="scrollable"
        scrollButtons="auto"
        allowScrollButtonsMobile
      >
        {tabs.map((tab) => (
          <Tab
            key={tab.key}
            label={tab.label}
            style={{ textTransform: "none" }}
          />
        ))}
      </Tabs>

      {tabs[tab]?.children}
    </div>
  );
};

export default UnitScholarAndPeers;
